import type { AppBootstrapOptions } from "../types/AppBootstrapOptions";
import { setApp } from "owa-config/lib/bootstrapOptions";
import initializeWindowTitle from "owa-shared-bootstrap/lib/initializeWindowTitle";
import { type OwaWorkload, setOwaWorkload } from "owa-workloads";
import { getCurrentModule, updateModule } from "owa-app-module-store";
import { getWindowTitle } from "owa-bootstrap/lib/initialization/getWindowTitle";
import { setVdir } from "owa-router";

export function updateModuleForVdirChange(options: AppBootstrapOptions): void {
    const newModule = options.appModuleProps.module;
    if (getCurrentModule() != newModule) {
        setOwaWorkload(options.workload || 0);
        setApp(newModule);
        initializeWindowTitle(() => getWindowTitle(options.getModuleName));
        options.routerOptions && setVdir(options.routerOptions.vdir);
        updateModule(newModule, getCurrentModule());
    }
}
